import { Component } from '@angular/core';

@Component({
  selector: 'app-te-role-permit',
  templateUrl: './te-role-permit.component.html',
  styleUrls: ['./te-role-permit.component.css']
})
export class TeRolePermitComponent {

}
